import { render, staticRenderFns } from "./historical-trend.component.vue?vue&type=template&id=108f74c8&"
import script from "./historical-trend.component.vue?vue&type=script&lang=ts&"
export * from "./historical-trend.component.vue?vue&type=script&lang=ts&"
import style0 from "./historical-trend.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports